<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="dialogShow"
    class="items-no-padding old-phone-validate sidebar-dialog">
    <div class="sidebar-content">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div>
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">
        <div class="content px-6">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
          >
            <el-form-item
              :label="$t('Current_mobile_phone_number')"
              prop="addPhones"
            >
              <el-input
                :value="`${allData.nationCode} ${allData.phone}`"
                disabled
              >
              </el-input>
            </el-form-item>
            <el-form-item
              :label="$t('User.phoneVerCode')"
              prop="code"
            >
              <div class="code-box pr">
                <el-input
                  v-model="form.code"
                  :placeholder="phFileter('Register.verText')"
                ></el-input>
                <div
                  class="sendMes pa theme-font"
                >
                                <span v-if="isCode"
                                      @click="getCode"
                                      class="active"
                                >{{$t('User.sendVeri')}}</span>
                  <span v-else>{{isCodeNumber}}s {{$t('User.sendDesc')}}</span>
                </div>
              </div>
            </el-form-item>
            <p class="desc-p">{{$t('If_the_old_phone_cannot_be_used_please_contact_customer_service_to_request_modification')}}</p>
          </el-form>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      class="footer-sidebar" slot="footer">
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >{{$t('cancel')}}</el-button>
      <vs-button
        @click="nextHandle"
        color="primary"
      >{{$t('root.next')}}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import { getDictListByType } from '@/api/home.js';
import { mapGetters } from 'vuex';
import { isMobile } from '@/utils/validate';
import {getOldPhoneVerCode, checkOldPhone} from '@/api/userCenter.js';

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: "oldPhoneDialog",
  components:{
    VuePerfectScrollbar
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    allData:{
      type: Object,
      default(){
        return {}
      }
    }
  },
  data() {
    let _this = this;
    var checkAddPhones = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('phoneEmtpyTips')));
      }
      setTimeout(() => {
        if (value === '') {
          callback(new Error(this.$t('User.plsInputNewPhone')));
        } else {
          if(this.phoneTitle !== '+86'){
            callback();
          }else {
            if (!isMobile(value)) {
              callback(new Error(this.$t('Register.errorPhon')));
            } else {
              callback();
            }
          }
        }
      }, 1000);
    };
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      title: _this.$t('mobile_phone'),

      form: {
        code: ''
      },
      rules: {
        code: [
          { required: true, message: this.$t('Partner.inputVer'), trigger: 'blur' }
        ]
      },
      phoneTitle: '+86',
      // 验证码
      loading: false,
      isCode: true,
      isCodeNumber: 60,
    }
  },
  watch: {

  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created(){
    this.getNationCodeList();
  },
  methods: {
    getNationCodeList(){
      getDictListByType({
        type: 'phoneList'
      }).then((res) => {
        if(res.data[0].type == 'phoneList') {
          this.nationCodeList = res.data;
          this.nationCodeListMaster = res.data;
        }
      })
    },
    dataFilter(val){
      this.phoneTitle = val;
      if (val) { //val存在
        this.nationCodeList = this.nationCodeListMaster.filter((item) => {
          if((item.label.indexOf(val) > -1) || (item.description.toUpperCase().indexOf(val.toUpperCase()) > -1)){
            return true
          }
        })
      } else {
        //val为空时，还原数组
        this.nationCodeList = this.nationCodeListMaster;
      }
    },
    getCode() {

      getOldPhoneVerCode().then((res) => {
        this.$message({
          message: this.$t('User.verCodeSendSuccess'),
          type: 'success'
        });
        this.isCode = false;
        this.timerOut();
        this.isCodeNumber = 60;
      });
    },
    timerOut() {
      let _this = this;
      let timer1 = setTimeout(() => {
        clearTimeout(timer1);
        if (_this.isCodeNumber > 0) {
          _this.isCodeNumber = --_this.isCodeNumber;
          _this.timerOut();
        } else {
          clearTimeout(timer1);
          this.isCode = true;
        }
      }, 1000);
    },

    close(){
      this.$emit('close')
    },
    closeHandle() {
      this.close();
    },
    phFileter(data){
      return this.$t(data);
    },

    interfaceAjaxSuccess(res){
      this.$emit('ajax-success',res.data.preOperationId);
    },
    nextHandle(){
      this.$refs.form.validate((valid) => {
        if(valid){
          let parmas = {
            verCode: this.form.code,
          };
          checkOldPhone(parmas).then((res) => {
            this.$message({
              message: `${this.$t('withgold.operatingSuccess')}`,
              type: 'success'
            });

            this.interfaceAjaxSuccess(res);
          });

        }else {
          console.log('error');
        }
      })
    },
    cancelHandle(){
      this.close();
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.old-phone-validate {
  .content {
    .text-box {
      background-color: #F8F8F8;
      padding: 10px;
      border-radius: 6px;
      .text-box-line {
        margin-bottom: 10px;
        font-size: 14px;
        .text-left {
          color: #A29FAE;
        }
        .data-right {
          color: #6E6B7B;
        }
      }
    }
    .elform {
      margin-top: 30px;
    }
    .code-box {
      position: relative;
      .sendMes {
        line-height: 14px;
        position: absolute;
        bottom: 13px;
        right: 20px;
        text-align: right;
        color: $themeColor;
        span {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.old-phone-validate {
  .vs-sidebar--items {

  }
  .scroll-area--customizer {
    height: calc(100% - 5rem);
  }
  .desc-p {
    font-size: 14px;
    color: #999999;
  }
  .vs-sidebar {
    position: fixed;
    z-index: 999;
    .sidebar-content {
    }
  }
  .footer-sidebar {
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
